import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { ThemeProvider } from "styled-components"
import { GridThemeProvider, BaseCSS } from "styled-bootstrap-grid"
import { useIntl } from "gatsby-plugin-react-intl"

import "normalize.css"

import "../../static/fonts/euclid-circular-b.css"
import GlobalStyle from "../styles/globalStyle"
import { lightTheme, darkTheme } from "../styles/globalTheme"
import { gridTheme } from "../styles"

import Header from "../components/Header"
import Footer from "../components/Footer"
import Notices from "../components/Notices"
import Notice from "../components/Notice"
import Snippet from "../components/Snippet"

import "../helpers/userTracker"
import { getUrlParam } from "../helpers"

const Layout = (props) => {
  const intl = useIntl()
  const [overlayHeight, setOverlayHeight] = useState(0)
  const [gaId, setGaId] = useState(0)
  const [landingNotice, setLandingNotice] = useState()

  useEffect(() => {
    if (props.overlayHeight) {
      setOverlayHeight(props.overlayHeight)
    }
  }, [props.overlayHeight])

  useEffect(() => {
    const noticeId = getUrlParam("show_landing_notice")
    if (noticeId) {
      setLandingNotice(noticeId)
    }
  }, [])

  useEffect(() => {
    if (typeof ga === "function") {
      ga(() => {
        const gaId = ga.getAll()[0].get("trackingId")
        setGaId(gaId)
        const disableStr = "ga-disable-" + gaId
        if (document.cookie.indexOf(disableStr + "=true") > -1) {
          window[disableStr] = true
        }
      })
    }
  }, [])

  return (
    <ThemeProvider theme={props.theme === "dark" ? darkTheme : lightTheme}>
      <GridThemeProvider gridTheme={gridTheme}>
        <BaseCSS />
        <GlobalStyle />
        <div className="site">
          <div className="site-content">
            {landingNotice && (
              <Notice
                id={landingNotice}
                pageId={props.pageId}
                isCloseable={true}
              >
                {intl.formatMessage({ id: "landingPages.noticeOver" })}
              </Notice>
            )}
            <Notices pageId={props.pageId} />
            {props.hasHeader && (
              <Header
                siteTitle={intl.formatMessage({ id: "title" })}
                layout={props.layout}
                pageId={props.pageId}
              />
            )}
            {props.children}
          </div>
          {props.hasFooter && <Footer offset={overlayHeight} />}
        </div>
      </GridThemeProvider>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
